// extracted by mini-css-extract-plugin
export default {"root_nothing":"Nothing_root_nothing__+xFdT"};